import * as React from 'react';

import { NetworkHealthToolService } from 'root/apps/NetworkHealthTool/services/NetworkHealthToolService';

let networkHealthToolServiceSingleton: NetworkHealthToolService;

export const useNetworkTestService = (): NetworkHealthToolService => {
  if (!networkHealthToolServiceSingleton)
    networkHealthToolServiceSingleton = new NetworkHealthToolService();
  React.useEffect(() => {
    return () => networkHealthToolServiceSingleton.closeConnection();
  }, []);

  return networkHealthToolServiceSingleton;
};
